// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"7":"e8339f0a","20":"f73b29a6","231":"ad410ead","369":"aa3adde4","495":"61368fb3","658":"17c4ed94","890":"c0a955a2","957":"5b82489d","970":"0265ac48"}[chunkId] + ".chunk.js";
};